module.exports = __webpack_public_path__ + "static/media/DataScience.2b223a66.png";